<form [formGroup]="formGroup" [ngStyle]="{'height': height}" name="otsc-plans-form">
  <div class="ot-row">
    <div class="ot-row__column">
      <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : nameCtrl.invalid}">
        <label for="otsc-plan-form-name" class="ot-form-control__label ot-form-control__required-indicator">
          <span i18n>Name</span>
        </label>
        <input id="otsc-plan-form-name" name="otsc-plan-form-name" formControlName="nameCtrl" i18n-placeholder
          placeholder="Enter plan name" type="text" class="ot-input" maxlength="50" autocomplete="off">
        @if (nameCtrl.touched && nameCtrl.invalid && nameCtrl.errors.required) {
        <p id="planNameEmptyErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
          Name cannot be empty.
        </p>
        }
        @if (nameCtrl.dirty && nameCtrl.errors && nameCtrl.errors.plannameExists) {
        <p id="planNameExistsErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
          Name already exists.
        </p>
        }
        @if (nameCtrl.dirty && nameCtrl.errors?.pattern) {
        <p id="planNameInvalidErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
          The specified plan name contains invalid characters.
        </p>
        }
      </div>
      <div class="ot-form-control">
        <label for="otsc-plan-form-desc" class="ot-form-control__label">Description</label>
        <textarea id="otsc-plan-form-desc" name="otsc-plan-form-desc" formControlName="descriptionCtrl" i18n-placeholder
          rows="3" placeholder="Enter description" class="ot-textarea"></textarea>
      </div>
      <div class="ot-form-control">
        <label class="ot-form-control__label ot-form-control__required-indicator" for="otsc-plan-form-env">
          <span i18n>Environment</span>
        </label>
        <input id="otsc-plan-form-env" name="otsc-plan-form-env" readonly="readonly" formControlName="envCtrl"
          type="text" class="ot-input">
      </div>
      @if (mode == FormMode.IMPORT) {
      <div class="ot-form-control">
        <label class="ot-form-control__label ot-form-control__required-indicator" for="otsc-plan-form-file" i18n>
          Plan file
        </label>
        <label class="ot-file-picker">
          <input type="file" id="otsc-plan-form-file" name="otsc-plan-form-file" formControlName="planFileNameCtrl"
            [(ngModel)]="planFile" (change)="fileBrowseHandler($event)">
          <span i18n>{{planToImportFileName ? planToImportFileName : choosePlanDefaultStr}}</span>
        </label>
      </div>
      }
    </div>
  </div>
</form>